<div class="header">
  <p>Cambio de contraseña</p>
  <img (click)="close()" class="my-auto" height="13" src="assets/icon/x.svg" alt="close">
</div>
<div class="body">

  <form [formGroup]="passwordForm">

    <label class="mnf-control form-password">
      <p class="mnf-control-label">Contraseña actual</p>
      <input class="mnf-input-form" [ngClass]="{ error: actual.touched && !actual.valid}" formControlName="actual"

        placeholder="********" type="password">
      <!-- <span class="msg-error" *ngIf="actual.errors">{{ actual.touched && actual.invalid ? errMsg : ""}}</span> -->
    </label>

    <label class="mnf-control form-password">
      <p class="mnf-control-label">Nueva contraseña</p>
      <input class="mnf-input-form" [ngClass]="{ error: password.touched && !password.valid}" formControlName="password"
        placeholder="********" [type]="passwordFlag"/>
        <i class="mnf-show cr-pointer fs-17" *ngIf="passwordFlag === 'password'" (click)="passwordFlag = 'text'"
        style="top: 55%"></i>
        <i class="mnf-hide cr-pointer fs-19" *ngIf="passwordFlag === 'text'" (click)="passwordFlag = 'password'"
        style="top: 54%"></i>
      <!-- <span class="msg-error" *ngIf="actual.errors">{{ actual.touched && actual.invalid ? errMsg : ""}}</span> -->
    </label>


    <div class="mb-2 col-9">
      <h3 class="fs-14 cl-neutral-3 fw-sbold">Recuerda que tu contraseña debe cumplir con lo siguiente: </h3>
      <ul class="pe-0 ps-4 mt-0">
        <li
          class="fs-11 m-0"
          *ngIf="password?.errors?.minLengthRequired">
          Contiene al menos 8 caracteres
        </li>
        <li
          class="fs-11 m-0 text-success"
          *ngIf="!password?.errors?.minLengthRequired">
          Contiene al menos 8 caracteres
        </li>

        <li
          class="fs-11 m-0"
          *ngIf="password?.errors?.numericCharacterMissing">
          Contiene al menos un caracter numérico (0-9)
        </li>

        <li
          class="fs-11 m-0 text-success"
          *ngIf="!password?.errors?.numericCharacterMissing">
          Contiene al menos un caracter numérico (0-9)
        </li>

        <li
          class="fs-11 m-0"
          *ngIf="password?.errors?.lowercaseMissing">
          Contiene al menos un caracter alfabético en minúscula (a-z)
        </li>

        <li
          class="fs-11 m-0 text-success"
          *ngIf="!password?.errors?.lowercaseMissing">
          Contiene al menos un caracter alfabético en minúscula (a-z)
        </li>

        <li
          class="fs-11 m-0"
          *ngIf="password?.errors?.uppercaseMissing">
          Contiene al menos un caracter alfabético en mayúscula (A-Z)
        </li>

        <li
          class="fs-11 m-0 text-success"
          *ngIf="!password?.errors?.uppercaseMissing">
          Contiene al menos un caracter alfabético en mayúscula (A-Z)
        </li>

        <li
          class="fs-11 m-0"
          *ngIf="password?.errors?.specialCharacterMissing">
          Contiene al menos un caracter especial (!&#64;#$)
        </li>

        <li
          class="fs-11 m-0 text-success"
          *ngIf="!password?.errors?.specialCharacterMissing">
          Contiene al menos un caracter especial (!&#64;#$)
        </li>

        <li
          class="fs-11 m-0 text-danger"
          *ngIf="password?.errors?.containsMonific">
          No debe incluir las palabra <strong>"monific"</strong>
        </li>

        <li
          class="fs-11 m-0 text-danger fw-bold"
          *ngIf="password?.errors?.sequentialCharacters || password?.errors?.consecutiveAlphabet">
          No debe tener mas de 3 caracteres secuenciales o identicos consecutivos (ej. abcd)
        </li>

        <li
          class="fs-11 m-0 text-danger fw-bold"
          *ngIf="password?.errors?.consecutiveNumbers">
          No debe tener mas de 3 caracteres numericos o identicos consecutivos (ej. 1234)
        </li>

        <li
          class="fs-11 m-0 text-danger fw-bold"
          *ngIf="password?.errors?.emailViolation">
          No debe incluir tu correo electrónico
        </li>

        <li
        class="fs-11 m-0 text-danger fw-bold"
        *ngIf="passwordForm.errors?.notMatchPass && passwordForm.controls.password.value
         && passwordForm.controls.confirmPassword.touched">
        La contraseña no coincide
        </li>

      </ul>
    </div>

    <label class="mnf-control form-password">
      <p class="mnf-control-label">Confirmar contraseña</p>
      <input class="mnf-input-form" [ngClass]="{ error: confPassword.touched && !confPassword.valid}"
        formControlName="confirmPassword" placeholder="********" [type]="passwordFlag2">
        <i class="mnf-show cr-pointer fs-17" *ngIf="passwordFlag2 === 'password'" (click)="passwordFlag2 = 'text'"
        style="top: 55%"></i>
        <i class="mnf-hide cr-pointer fs-19" *ngIf="passwordFlag2 === 'text'" (click)="passwordFlag2 = 'password'"
        style="top: 54%"></i>
      <!-- <span class="msg-error" *ngIf="actual.errors">{{ actual.touched && actual.invalid ? errMsg : ""}}</span> -->
    </label>

    <div class="w-100 text-center my-4">
      <button mat-button class="w-25" type="button" (click)="changePass()"
        [disabled]="passwordForm.invalid">Continuar</button>
    </div>

  </form>

</div>
